import type { HTMLAttributes } from 'react';
import { cn } from '../lib/utils';

/** DESIGN.md §6 Badge tones. Outline only, no fill; text always carries the meaning. */
export type BadgeTone = 'positive' | 'negative' | 'warning' | 'accent' | 'neutral';

const tones: Record<BadgeTone, string> = {
  positive: 'border-[var(--positive)] text-[var(--positive)]',
  negative: 'border-[var(--negative)] text-[var(--negative)]',
  warning: 'border-[var(--warning)] text-[var(--warning)]',
  accent: 'border-[var(--line-strong)] text-[var(--ink)]',
  neutral: 'border-[var(--line-strong)] text-[var(--ink-soft)]',
};

export function Badge({
  tone = 'neutral',
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tone?: BadgeTone }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        tones[tone],
        className,
      )}
      {...props}
    />
  );
}
